import React from "react";

import { StatsTotalsDto } from "services/stats/restModels";

import { useStatisticsContext } from "features/Statistics/context";
import { compareChange, formatChange } from "features/Statistics/lib/statsChange";
import { StatsMetric } from "features/Statistics/types";

import { Change, Footer, Grid, Hint, Tile, Title, Value } from "./styles";

interface TileConfig {
    metric: StatsMetric;
    title: string;
    // Значение метрики в минорных единицах (для «Заказов» — просто счётчик).
    value: (totals: StatsTotalsDto) => number;
}

const TILES: TileConfig[] = [
    { metric: "revenue", title: "Выручка", value: (totals) => totals.revenue?.price || 0 },
    { metric: "orders", title: "Заказы", value: (totals) => totals.ordersCount },
    {
        metric: "averageCheck",
        title: "Средний чек",
        value: (totals) => totals.averageCheck?.price || 0,
    },
];

export const SummaryTiles = () => {
    const { summary, compareLabel, formatPrice, openChart } = useStatisticsContext();

    if (!summary) return null;

    const { current, previous } = summary;

    const renderValue = (config: TileConfig): string => {
        if (config.metric === "orders") return String(current.ordersCount);

        const price = config.metric === "revenue" ? current.revenue : current.averageCheck;

        // Заказов за период не было — форматировать нечего, но и «пусто» показывать нельзя:
        // ноль здесь честнее, чем прочерк.
        return price === null ? "0" : formatPrice(price);
    };

    return (
        <Grid>
            {TILES.map((config) => {
                const change = previous
                    ? compareChange(config.value(current), config.value(previous))
                    : null;

                return (
                    <Tile
                        key={config.metric}
                        type="button"
                        onClick={() => openChart(config.metric)}
                        aria-label={`${config.title} — показать график`}
                    >
                        <Title>{config.title}</Title>
                        <Value>{renderValue(config)}</Value>
                        <Footer>
                            {change ? (
                                <>
                                    <Change $tone={change.tone}>{formatChange(change)}</Change>
                                    <span>{compareLabel}</span>
                                </>
                            ) : (
                                <Hint>Не с чем сравнить: за прошлый период заказов не было</Hint>
                            )}
                        </Footer>
                    </Tile>
                );
            })}
        </Grid>
    );
};
